import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
//@ts-ignore
import VueMask from 'v-mask'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
// @ts-ignore
import RegistrationService from "@/apis/registration";
// @ts-ignore
import AccountService from "@/components/account/account.service";
import './styles/styles.scss';
import LocationService from "@/apis/location";
import JobsService from "@/apis/orders";
import RequestHelper from "@/helpers/request";
import WorkOrdersService from "@/apis/prev-orders";
import FaqService from './apis/faq';
import axios from 'axios';
import * as service from "@/methods/service";
import * as serviceApi from "@/apis/service";

Vue.config.productionTip = false;
Vue.use(Vuelidate)
Vue.use(VueMask, {
	placeholders: {
		mm: [/[1-12]/],
	}
});

const accountService = new AccountService(store, (<any>Vue).cookie, router);

router.beforeEach(async (to, from, next) => {

	if(to.name === 'secondStep' && from.name === 'thirdStep'){
		//@ts-ignore
		if(localStorage.getItem('isFirstStepComplited') === 'true' ){
			store.commit("clearStoreEdit");
			store.commit('updateAddress', localStorage.getItem('address') );
			store.commit('updatePostcode', localStorage.getItem('postcode'));
			store.commit('updateCity', localStorage.getItem('city'));
			store.commit('updateStateCountry', localStorage.getItem('stateCountry'));
			store.commit('updateCountry', localStorage.getItem('country'));
			store.commit('updateFranchiseID', localStorage.getItem('franchiseID'));
			store.commit('setFirstStepComplited');
		}
		else {
			router.push({ name: "Home" });
			store.commit("clearStore");
		}
	}

	if(to.name === 'Home'){
		store.commit("clearStore");
		if(sessionStorage.getItem('endDate') && sessionStorage.getItem('startDate')){
			sessionStorage.removeItem('endDate')
			sessionStorage.removeItem('startDate')
		}
		if(sessionStorage.getItem('address')){
			store.commit('updateAddress', sessionStorage.getItem('address') );
			store.commit('updatePostcode', sessionStorage.getItem('postcode'));
			store.commit('updateCity', sessionStorage.getItem('city'));
			store.commit('updateStateCountry', sessionStorage.getItem('stateCountry'))
			store.commit('updateCountry', sessionStorage.getItem('country'));
			store.commit('updateFranchiseID', sessionStorage.getItem('franchiseID'));
			store.commit('setFirstStepComplited');
		}
	}


	if(to.name === 'secondStep' && from.name !== 'thirdStep'){
		//@ts-ignore
		if(localStorage.getItem('address') && localStorage.getItem('postcode') && localStorage.getItem('city')
			&& localStorage.getItem('country') && localStorage.getItem('stateCountry')){
			store.commit('updateAddress', localStorage.getItem('address') );
			store.commit('updatePostcode', localStorage.getItem('postcode'));
			store.commit('updateCity', localStorage.getItem('city'));
			store.commit('updateStateCountry', localStorage.getItem('stateCountry'));
			store.commit('updateCountry', localStorage.getItem('country'));
			store.commit('updateFranchiseID', localStorage.getItem('franchiseID'));
			store.commit('setFirstStepComplited');
		}
		else {
			router.push({ name: "Home" });
			store.commit("clearStore");
		}
	}

	if(to.name === 'firstStep'){
		//@ts-ignore
		if(localStorage.getItem('isSecondStepComplited') === 'true' ){
			store.commit('updateAddress', localStorage.getItem('address') );
			store.commit('updatePostcode', localStorage.getItem('postcode'));
			store.commit('updateCity', localStorage.getItem('city'));
			store.commit('updateStateCountry', localStorage.getItem('stateCountry'));
			store.commit('updateCountry', localStorage.getItem('country'));
			store.commit('updateServiceID', localStorage.getItem('serviceID'));
			store.commit('updateFranchiseID', localStorage.getItem('franchiseID'));
			store.commit('setFirstStepComplited');
			store.commit('setSecondStepComplited');
		}
		else {
			router.push({ name: "Home" });
			store.commit("clearStore");
		}
	}

	if(to.name === 'thirdStep'){
		//@ts-ignore
		if(localStorage.getItem('isThirdStepComplited') === 'true' ){
			store.commit('updateAddress', localStorage.getItem('address') );
			store.commit('updatePostcode', localStorage.getItem('postcode'));
			store.commit('updateCity', localStorage.getItem('city'));
			store.commit('updateStateCountry', localStorage.getItem('stateCountry'));
			store.commit('updateCountry', localStorage.getItem('country'));

			store.commit('updateServiceID', localStorage.getItem('serviceID'));
			store.commit('updateFranchiseID', localStorage.getItem('franchiseID'));

			store.commit('setDeliveryDate', localStorage.getItem('deliveryDate'));
			store.commit('setDeliveryRouteID', localStorage.getItem('deliveryRouteID'));
			store.commit('setDeliveryTime', localStorage.getItem('deliveryTime'));

			store.commit('setPickUpDate', localStorage.getItem('pickUpDate'));
			store.commit('setPickUpRouteID', localStorage.getItem('pickUpRouteID'));
			store.commit('setPickUpTime', localStorage.getItem('pickUpTime'));

			store.commit('setDeliveryLockID', localStorage.getItem('deliveryLockID'));
			store.commit('setPickUpLockID', localStorage.getItem('pickUpLockID'));


			store.commit('setFirstStepComplited');
			store.commit('setSecondStepComplited');
			store.commit('setThirdStepComplited');
		}
		else {
			router.push({ name: "Home" });
			store.commit("clearStore");
		}
	}

	if(from.name === 'thirdStep') {
		store.commit('stopTimer')
	}
	if(to.name === 'thirdStep') {
		store.dispatch('continueTimer');
	}

	if(to.name === 'finish'){
		//@ts-ignore
		if(localStorage.getItem('isFourthStepComplited') === 'true' ){
			store.commit('updateAddress', localStorage.getItem('address') );
			store.commit('updatePostcode', localStorage.getItem('postcode'));
			store.commit('updateCity', localStorage.getItem('city'));
			store.commit('updateStateCountry', localStorage.getItem('stateCountry'));
			store.commit('updateCountry', localStorage.getItem('country'));

			store.commit('updateServiceID', localStorage.getItem('serviceID'));
			store.commit('updateFranchiseID', localStorage.getItem('franchiseID'));

			store.commit('setDeliveryDate', localStorage.getItem('deliveryDate'));
			store.commit('setDeliveryRouteID', localStorage.getItem('deliveryRouteID'));
			store.commit('setDeliveryTime', localStorage.getItem('deliveryTime'));

			store.commit('setPickUpDate', localStorage.getItem('pickUpDate'));
			store.commit('setPickUpRouteID', localStorage.getItem('pickUpRouteID'));
			store.commit('setPickUpTime', localStorage.getItem('pickUpTime'));

			store.commit('setDeliveryLockID', localStorage.getItem('deliveryLockID'));
			store.commit('setPickUpLockID', localStorage.getItem('pickUpLockID'));

			store.commit('setjobID', localStorage.getItem('jobID'));

			store.commit('setFirstStepComplited');
			store.commit('setSecondStepComplited');
			store.commit('setThirdStepComplited');
			store.commit('setFourthStepComplited');
		}
		else {
			router.push({ name: "Home" });
			store.commit("clearStore");
		}
	}

	if (store.getters.token != null) {
		const requestData = {
			securityToken: store.getters.token,
		};
		const response = await serviceApi.checkSecurityToken(requestData);
		const { data } = response
		if ("errNo" in data && data.errNo == '-421' || data.errNo == '-422') {
			store.commit("logout");
			router.push({ name: "Home" });
			await service.updateSecurityToken();
			next();
		} else {
			next();
		}
	} else {
		// @ts-ignore
		const { securityToken } = (await accountService.getToken('1', 'Vonigo', '3b3e9bf9e01962fe4fb9ef658533392e', 'API.Booking'));
		store.commit('updateToken', securityToken);
		next();
	}
})

// axios.interceptors.response.use(
// 	async (response) => {
// 		// if (response.data.errNo == '-421' || response.data.errNo == '-422' && response.data.errNo) {
// 		// 	await service.updateSecurityToken();
// 		//
// 		// 	// // если хоть раз приходит "неавторизован" - разлогинить юзера
// 		// 	// store.commit("logout");
// 		// 	// // отправляем на стр входа
// 		// 	// router.push({ name: "Home" });
// 		// }
// 		return response;
// 	},
// 	(error) => {
// 		if (error.response && error.response.data) {
// 			if (error.response.status === 401 || error.response.status === 403) {
// 				// если хоть раз приходит "неавторизован" - разлогинить юзера
// 				store.commit("logout");
// 				// отправляем на стр входа
// 				router.push({ name: "Home" });
// 			}
// 			return Promise.reject(error.response.data);
// 		}
// 		return Promise.reject(error.message);
// 	}
// );

new Vue({
	router,
	store,
	vuetify,
	provide: {
		accountService: () => accountService,
		registrationService: () => new RegistrationService(),
		locationService: () => new LocationService(),
		jobsService: () => new JobsService(),
		workOrdersService: () => new WorkOrdersService(),
		requestHelper: () => new RequestHelper(),
		faqService: () => new FaqService(),
	},
	render: (h) => h(App),
}).$mount('#app');
